import * as React from 'react';
import './Station.scss';
import { Spacing, LoadingBar, colors } from 'react-elemental';
import Select from 'react-select';
import Stats from '../../Stats';
import StationMap from './StationMap';
import StationCards from './StationCards';
import ProductCarousel from '../../../Commons/ProductCarousel';
import { customSelect } from '../../../../commons/style/style';

const ZOOM_MOBILE = 9; // Zoom alejado para ver la región en móvil
const MAX_NEARBY_STATIONS = 10; // Configurable: cantidad de estaciones cercanas a mostrar

class Station extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Estaciones",
      selectedRegionId: null,
      selectedCommune: null,
      selectedStation: null,
      searchAdvance: false,
      geolocation: false,
      geolocationDenied: false, // Usuario rechazó el permiso del navegador
      showLocationConsent: false, // Ya no se usa banner propio
      nearbyStations: [],
      center: {
        lat: -33.4534775,
        lng: -70.7144413,
      },
      guest: null,
      userLocation: null, // Nuevo: ubicación del usuario para el punto azul
      zoom: 8, // Zoom alejado para ver Santiago y alrededores
    };
    this.mapRef = null; // Referencia al mapa de Google para transiciones suaves
    this.getCommunes = this.getCommunes.bind(this);
    this.getStations = this.getStations.bind(this);
    this.selectStation = this.selectStation.bind(this);
    this.selectCommune = this.selectCommune.bind(this);
    this.selectRegion = this.selectRegion.bind(this);
    this.showAdvance = this.showAdvance.bind(this);
    this.initMap = this.initMap.bind(this);
    this.calculateLinealDistance = this.calculateLinealDistance.bind(this);
    this.calculateLinealDistanceWithStations = this.calculateLinealDistanceWithStations.bind(this);
    this.requestGeolocation = this.requestGeolocation.bind(this);
    this.handleConsentAccept = this.handleConsentAccept.bind(this);
    this.handleConsentDeny = this.handleConsentDeny.bind(this);
    this.waitForStationsAndCalculate = this.waitForStationsAndCalculate.bind(this);
    this.handleMapLoad = this.handleMapLoad.bind(this);
    this.getStations(null);
  }

  getCommunes(regionId) {
    this.props.getCommunes(regionId);
  }

  // Callback cuando el mapa se carga - guarda referencia para transiciones suaves
  handleMapLoad(map) {
    this.mapRef = map;
  }

  showAdvance() {
    const isGoingBack = this.state.searchAdvance; // Si está en true, va a volver
    
    if (isGoingBack && this.state.geolocation && this.state.userLocation) {
      // Volver a sucursales cercanas: resetear a ubicación del usuario
      const userLoc = this.state.userLocation;
      this.setState({ 
        searchAdvance: false,
        selectedCommune: null,
        selectedRegionId: null,
        center: userLoc,
        title: "Estaciones cercanas",
        showDistance: true,
        zoom: 12 // Acercar zoom cuando vuelve a sucursales cercanas
      }, () => {
        // Pasar la ubicación directamente para evitar problemas de timing
        this.calculateLinealDistance(userLoc);
      });
    } else {
      // Ir a búsqueda avanzada
      this.setState({ searchAdvance: !this.state.searchAdvance });
    }
  }

  getStations(communeId) {
    this.props.getStations(communeId);
    // console.log('getStations');
  }

  selectStation(item) {
    const stationId = parseInt(item.value);
    const selectedStation = this.props.stations.find(
      (station) => station.id === stationId,
    );
    if (selectedStation) {
      // Asegurar que las coordenadas sean números
      const temp = { 
        lat: parseFloat(selectedStation.lat), 
        lng: parseFloat(selectedStation.lng) 
      };
      
      // Usar panTo para transición suave si el mapa está disponible
      if (this.mapRef) {
        this.mapRef.panTo(temp);
        // Hacer zoom gradual después del pan
        setTimeout(() => {
          this.setState({ zoom: 14, center: temp });
        }, 300);
      } else {
        this.setState({ center: temp, zoom: 14 });
      }
      
      this.setState({ selectedStation });
      this.props.onChangeStation(selectedStation);
      // Scroll to bottom
      setTimeout(() => {
        let rootElement = document.getElementById('label-products');
        if (rootElement == null) {
          rootElement = document.documentElement;
          rootElement.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth',
          });
        } else {
          rootElement.scrollIntoView();
        }
      }, 700);
    }
  }

  selectCommune(item) {
    const communeId = parseInt(item.value);
    const selectedCommune = this.props.communes.find(
      (commune) => commune.id === communeId,
    );
    if (selectedCommune) {
      const temp = { lat: selectedCommune.lat, lng: selectedCommune.lng };
      this.setState({ center: temp });
      this.setState({ zoom: 13 });
      if (window.innerWidth < 648) {
        this.setState({ zoom: ZOOM_MOBILE });
      }
      this.setState({ selectedCommune });
      this.setState({ selectedStation: null });
      this.setState({ searchAdvance: false });
      setTimeout(() => this.calculateLinealDistance(), 500);
    }
  }

  selectRegion(item) {
    this.setState({ showDistance: false });
    const regionId = parseInt(item.value);
    this.getCommunes(regionId);
    this.setState({ selectedRegionId: regionId });
    this.setState({ selectedCommune: null });
    this.setState({ selectedStation: null });
  }

  // Maneja cuando el usuario acepta compartir ubicación
  handleConsentAccept() {
    this.setState({ showLocationConsent: false });
    this.requestGeolocation();
  }

  // Maneja cuando el usuario rechaza compartir ubicación
  handleConsentDeny() {
    this.setState({ 
      showLocationConsent: false,
      geolocationDenied: true,
      searchAdvance: true // Mostrar búsqueda manual automáticamente
    });
    this.waitForStationsAndCalculate();
  }

  // Solicita la geolocalización al navegador
  requestGeolocation() {
    // DEBUG: Simular ubicación en Santiago Centro (comentar para usar ubicación real)
    const SIMULATE_LOCATION = false; // Cambiar a true para simular ubicación
    const SIMULATED_COORDS = { lat: -33.4489, lng: -70.6693 }; // Santiago Centro
    // const SIMULATED_COORDS = { lat: -33.0245, lng: -71.5518 }; // Viña del Mar
    // const SIMULATED_COORDS = { lat: -33.4372, lng: -70.6506 }; // Providencia
    
    if (SIMULATE_LOCATION) {
      const userCoords = SIMULATED_COORDS;
      this.setState({ 
        geolocation: true,
        geolocationDenied: false,
        title: "Estaciones cercanas",
        center: userCoords,
        guest: userCoords,
        userLocation: userCoords,
        showDistance: true,
        zoom: 12
      }, () => {
        this.waitForStationsAndCalculate(userCoords);
      });
      return;
    }
    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userCoords = { 
            lat: position.coords.latitude, 
            lng: position.coords.longitude 
          };
          this.setState({ 
            geolocation: true,
            geolocationDenied: false,
            title: "Estaciones cercanas",
            center: userCoords,
            guest: userCoords,
            userLocation: userCoords, // Para el punto azul en el mapa
            showDistance: true,
            zoom: 12 // Acercar zoom cuando tenemos ubicación
          }, () => {
            this.waitForStationsAndCalculate(userCoords);
          });
        }, 
        (err) => {
          // Usuario rechazó el permiso del navegador
          this.setState({ 
            geolocationDenied: true,
            showLocationConsent: false,
            searchAdvance: true
          });
          this.waitForStationsAndCalculate();
        }
      );
    } else {
      // Navegador no soporta geolocalización
      this.setState({ 
        geolocationDenied: true,
        showLocationConsent: false,
        searchAdvance: true
      });
      this.waitForStationsAndCalculate();
    }
  }

  // Método auxiliar para esperar las estaciones y calcular
  waitForStationsAndCalculate(coords = null) {
    this.pendingCoords = coords;
    
    // Limpiar cualquier intervalo anterior
    if (this.stationCheckInterval) {
      clearInterval(this.stationCheckInterval);
    }
    
    const tryCalculate = () => {
      const currentStations = this.props.stations;
      if (currentStations && currentStations.length > 0) {
        if (this.stationCheckInterval) {
          clearInterval(this.stationCheckInterval);
          this.stationCheckInterval = null;
        }
        this.calculateLinealDistanceWithStations(coords, currentStations);
        // Forzar re-render
        this.forceUpdate();
        return true;
      }
      return false;
    };
    
    // Intentar inmediatamente
    if (tryCalculate()) {
      return;
    }
    
    // Polling activo para esperar las estaciones
    let attempts = 0;
    const maxAttempts = 50; // 10 segundos máximo
    this.stationCheckInterval = setInterval(() => {
      attempts++;
      if (tryCalculate()) {
        return;
      }
      if (attempts >= maxAttempts) {
        clearInterval(this.stationCheckInterval);
        this.stationCheckInterval = null;
      }
    }, 200);
  }

  initMap() {
    // No calculamos estaciones aquí - esperamos a que el usuario decida sobre ubicación
    // El cálculo se hace en handleConsentAccept o handleConsentDeny
  }

  calculateLinealDistance(forceCenter = null) {
    this.calculateLinealDistanceWithStations(forceCenter, this.props.stations);
  }

  calculateLinealDistanceWithStations(forceCenter = null, stations = []) {
    if (stations.length === 0) {
      return;
    }
    
    const getKm = (lat1, lon1, lat2, lon2) => {
      const rad = (x) => (x * Math.PI) / 180;
      const R = 6371; // Ratio of Earth in km
      const dLat = rad(lat2 - lat1);
      const dLong = rad(lon2 - lon1);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const d = R * c;
      return d;
    };

    // Usar forceCenter si se pasa, sino userLocation si existe, sino center
    const referencePoint = forceCenter || this.state.userLocation || this.state.center;

    const max_stations = MAX_NEARBY_STATIONS;
    let nearby;
    if (this.state.selectedCommune) {
      nearby = stations.filter((item) => {
        return item.commune.id === this.state.selectedCommune.id;
      });
      this.setState({nearbyStations: nearby});
    } else {
      const stationsList = stations.map((item) => {
        return {
          ...item,
          distance: getKm(referencePoint.lat, referencePoint.lng, parseFloat(item.lat), parseFloat(item.lng)),
        };
      });

      nearby = stationsList.sort((a, b) => a.distance - b.distance);
      this.setState({nearbyStations: nearby.slice(0, max_stations)});
    }
    if (nearby && nearby.length > 0) {
      this.setState({center: {lat: nearby[0].lat, lng: nearby[0].lng}});
    }
  }

  componentDidMount() {
    if (window.innerWidth < 648) {
      this.setState({ zoom: ZOOM_MOBILE });
    }
    // Solicitar geolocalización directamente al navegador
    this.requestGeolocation();
  }

  componentWillUnmount() {
    // Limpiar intervalos al desmontar
    if (this.stationCheckInterval) {
      clearInterval(this.stationCheckInterval);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    // Cuando las estaciones se cargan
    if (nextProps.stations.length > 0 && this.props.stations.length === 0) {
      this.stationsLoaded = true;
      // Usar pendingCoords si existe, sino userLocation, sino null
      const coords = this.pendingCoords || this.state.userLocation || null;
      this.calculateLinealDistanceWithStations(coords, nextProps.stations);
    }
  }

  render() {
    const { regions, communes, stations } = this.props;
    const { nearbyStations } = this.state;
    const sucursals = nearbyStations;
    return (
      <div className="mt-3">
        <h3 className="custom-title black mt-5 d-none d-md-block">
          Selecciona una Estación de
          Servicio
        </h3>
        <div className="mb-5 text-muted margin-top--5 d-none d-md-block">
          Elige la Estación de
          Servicio más cercana para agendar tu cambio de aceite
        </div>

        {
          this.state.center.lat !== null && this.state.center.lng !== null
          && (
            <div className="row">
              <div className="col-lg-3 nearby-stations order-1 order-lg-0 mt-3 mt-lg-0">
                <h5 className="mb-3">{ this.state.title }</h5>
                
                {/* Botón arriba cuando está en búsqueda avanzada CON ubicación */}
                {this.state.searchAdvance && this.state.geolocation && (
                  <button type="button" className="btn btn-sm btn-search w-100 mb-3" onClick={this.showAdvance}>
                    ← Volver a estaciones cercanas
                  </button>
                )}
                
                {/* Mensaje arriba cuando está en búsqueda avanzada SIN ubicación */}
                {this.state.searchAdvance && this.state.geolocationDenied && !this.state.geolocation && (
                  <div className="location-denied-message mb-3 p-2">
                    <p className="small mb-0 text-muted">
                      No pudimos acceder a tu ubicación. Usa la búsqueda manual para encontrar estaciones.
                    </p>
                  </div>
                )}
                
                {/* Lista de estaciones */}
                {!this.state.searchAdvance && (
                  <div className="stations-list">
                    <StationCards
                      stations={ sucursals }
                      selectStation={this.selectStation}
                      selectedStation={this.state.selectedStation}
                      showDistance={this.state.showDistance}
                    ></StationCards>
                  </div>
                )}
                
                {/* Botón fijo abajo - solo cuando NO está en búsqueda avanzada */}
                {!this.state.searchAdvance && (
                  <div className="station-actions">
                    <button type="button" className="btn btn-sm btn-search w-100" onClick={this.showAdvance}>Buscar otras estaciones</button>
                  </div>
                )}
                
                {this.state.searchAdvance && (
                  <div className="row mt-2">
                    <div className="col-12">
                      <Spacing bottom>
                        {/*<label className="text-muted custom-label margin-bottom-10">Región</label>*/}
                        <Select
                          className="rounded-pill"
                          styles={customSelect}
                          placeholder="Selecciona una región"
                          onChange={this.selectRegion}
                          noOptionsMessage={() => 'No hay regiones cargadas'}
                          options={regions.map((region) => ({label: region.name, value: region.id.toString()}))}
                        />
                        {
                          regions.length === 0
                          && (
                            <div className="p-2">
                              <LoadingBar
                                color={colors.red}
                                thickness={4}
                                duration={500}
                                delay={50}
                              />
                            </div>
                          )
                        }
                      </Spacing>
                    </div>

                    <div className="col-12">
                      <Spacing bottom>
                        {/*<label className="text-muted custom-label margin-bottom-10">Comuna</label>*/}
                        <Select
                          styles={customSelect}
                          placeholder="Selecciona una comuna"
                          value={this.state.selectedCommune
                            ? {
                              value: this.state.selectedCommune.id.toString(),
                              label: this.state.selectedCommune.name,
                            }
                            : null}
                          onChange={this.selectCommune}
                          noOptionsMessage={() => 'Debe seleccionar una región para mostrar sus comunas'}
                          options={communes.map((commune) => ({label: commune.name, value: commune.id.toString()}))}
                        />
                        {
                          ((this.state.selectedRegionId !== null && communes.length
                            === 0)
                            || (this.state.selectedRegionId !== null && communes.length
                              > 0 && communes[0].region !== this.state.selectedRegionId))
                          && (
                            <div className="p-2">
                              <LoadingBar
                                color={colors.red}
                                thickness={4}
                                duration={500}
                                delay={50}
                              />
                            </div>
                          )
                        }
                      </Spacing>
                    </div>
                  </div>
                )}
              </div>
              <div className="col-lg-9 col-xs-12 col-sm-12 ml-auto mr-auto order-0 order-lg-1">
                <StationMap
                  center={this.state.center}
                  zoom={this.state.zoom}
                  stations={stations}
                  selectStation={this.selectStation}
                  userLocation={this.state.userLocation}
                  onMapLoad={this.handleMapLoad}
                />
              </div>
            </div>
          )
        }
        <ProductCarousel products={ this.props.products } />
        <Stats
          step={ 1 }
          { ...this.props }
          disabled={ this.state.selectedStation === null }
        />
      </div>
    );
  }
}

export default Station;
